import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ProductsService from "../services/ProductsService";
export default function Products() {
    const location = useLocation();
    const navigate = useNavigate();
    const queryParams = new URLSearchParams(location.search);
    const category = queryParams.get("category") || "hoodies";
    const [products, setProducts] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    useEffect(() => {
        setProducts([]);
        setPage(1);
        setHasMore(true);
        loadProducts(1, true);
    }, [category]);
    const loadProducts = (pageToLoad, isInitial = false) => {
        setIsLoading(true);
        ProductsService.getProducts({ category, page: pageToLoad }).then((res) => {
            const newProducts = res.data || [];
            if(isInitial) {
                setProducts(newProducts);
            } 
            else {
                setProducts((prev) => [...prev, ...newProducts]);
            }
            if(newProducts.length === 0 || newProducts.length < 8) {
                setHasMore(false);
            }
        }).catch((err) => console.log("Error:", err)).finally(() => setIsLoading(false));
    };
    const handleLoadMore = () => {
        const nextPage = page + 1;
        setPage(nextPage);
        loadProducts(nextPage);
    };
    const categories = [
        { key: "overtees", label: "Oversized Tees" },
        { key: "hoodies", label: "Hoodies" },
        { key: "sweat shirt", label: "SweatShirts" },
    ];
    function selectCategory(catKey) {
        if (catKey === "all") navigate("/products");
        else navigate(`/products?category=${encodeURIComponent(catKey)}`);
    }
    return (
        <div className="dark:bg-gray-800 flex min-h-screen">
            <aside className="hidden md:flex sticky top-0 left-0 h-[calc(100vh-4rem)] w-64 bg-white dark:bg-gray-900 shadow-lg border-r border-gray-200 dark:border-gray-700 flex-col z-10">
                <div className="px-6 py-6 font-bold text-xl uppercase dark:text-white border-b dark:border-gray-700 sticky top-0 bg-white dark:bg-gray-900 z-10">
                    Categories
                </div>
                <nav className="flex-1 overflow-y-auto">
                    <ul className="py-4 space-y-2 text-gray-700 dark:text-gray-300">
                        {categories.filter(c => c.key !== "all").map(({ key, label }) => (
                            <li key={key} className="dark:hover:bg-gray-700">
                                <Link to={`/products?category=${encodeURIComponent(key)}`} className={`${category === key ? "font-bold bg-gray-300 hover:cursor-no-drop dark:bg-gray-700" : "hover:bg-gray-200"} block px-2 py-1`}>
                                    {label}
                                </Link>
                            </li>
                        ))} 
                    </ul>
                </nav>
            </aside>
            <main className="flex-1 flex flex-col items-center px-4 py-6 z-0 w-full">
                <div className="md:hidden w-full flex overflow-x-auto space-x-4 mb-6 px-2">
                    {categories.map(({ key, label }) => {
                        const isSelected = (key === "all" && !category) || (key !== "all" && category === key);
                        return (
                        <button key={key} onClick={() => selectCategory(key)} className={`flex-shrink-0 flex items-center border-2 px-3 py-1 uppercase rounded ${
                            isSelected
                                ? "bg-black text-white border-black dark:border-white"
                                : "text-black dark:text-white border-black dark:border-white bg-transparent"
                            }`}
                        >
                            {label}
                        </button>
                        );
                    })}
                </div>
                <div className="text-2xl dark:text-white uppercase py-4 font-bold w-full max-w-7xl text-center">
                    {category === "overtees" ? "Oversized Tees" : category === "" || category === "all" ? "All" : category}
                </div>
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 gap-6 w-full max-w-7xl">
                {isLoading && products.length === 0 ? (
                    Array(8).fill(null).map((_, i) => (
                    <div key={i} className="col-span-1 flex flex-col items-center bg-gray-200 dark:bg-gray-700 rounded-lg shadow-md overflow-hidden w-full animate-pulse">
                        <div className="w-full h-48 bg-gray-300 dark:bg-gray-600" />
                        <div className="w-full px-4 py-2 dark:bg-gray-600">
                        <div className="h-4 bg-gray-400 dark:bg-gray-500 rounded w-3/4 mb-2" />
                        <div className="h-4 bg-gray-400 dark:bg-gray-500 rounded w-1/2 mx-auto" />
                        </div>
                    </div>
                    ))
                ) : products && products.length >0 ? (
                    products.map((product) => (
                    <Link key={product._id} to={`/products/${product.itemId}`} className="flex flex-col group">
                        <div className="w-full aspect-[3/4] overflow-hidden shadow-md relative">
                            <img src={product.image} alt={product.name} className="w-full h-full object-fit transition-transform duration-500 group-hover:scale-105" />
                            <div className="absolute top-[80%] left-0 bg-red-700 text-white px-2 py-1 rounded-r-xl text-xs sm:text-sm md:text-md lg:text-lg xl:text-xl">Save {Math.round(((product.price/product.actualPrice)*100))}%</div>
                        </div>
                        <div className="pt-2 text-center font-semibold text-black dark:text-white truncate">
                            {product.name}
                        </div>
                        <div className="flex flex-row gap-5 justify-center">
                            <p className="text-sm line-through font-bold">₹ {product.actualPrice}</p>
                            <p className="text-sm font-bold">₹ {product.price}</p>
                        </div>
                    </Link>
                    ))
                ) : (
                    <div className="text-center text-gray-600 col-span-full dark:text-gray-300 w-full py-10 text-xl font-semibold">
                        Coming Soon
                    </div>
                )}
                </div>
                {hasMore && (
                    <button onClick={handleLoadMore} disabled={isLoading} className="mt-6 px-6 py-2 bg-gray-700 text-white rounded hover:bg-gray-600 transition disabled:opacity-50">
                        {isLoading ? "Loading..." : "Load More"}
                    </button>
                )}
            </main>
        </div>
    );
}
